import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { HISTORY_LOAD_ERROR_TOAST, HISTORY_RETRY_LABEL } from '../lib/history-copy'

interface Props {
  onRetry: () => void
  isRetrying?: boolean
}

export function HistoryErrorState({ onRetry, isRetrying = false }: Readonly<Props>) {
  return (
    <Box
      sx={{ textAlign: 'center', py: 6 }}
      data-testid="history-error-state"
      role="status"
    >
      <Typography sx={{ color: '#64748b', fontSize: '16px', mb: 2 }}>
        {HISTORY_LOAD_ERROR_TOAST}
      </Typography>
      <Button
        variant="outlined"
        onClick={onRetry}
        disabled={isRetrying}
        data-testid="history-retry-button"
      >
        {HISTORY_RETRY_LABEL}
      </Button>
    </Box>
  )
}
